import React, { Component } from "react";
import ReactMapGL, {
  Marker,
  Popup,
  NavigationControl,
  FullscreenControl
} from "react-map-gl";
import CityPin from "./city-pin";

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //      style: "mapbox://styles/barbotha/cjved3kfr00k61fod82xcq4tc",
      //style: "mapbox://styles/barbotha/cjxyxhap718sc1cqytp16gglg",
      //style: "mapbox://styles/barbotha/cjxyxsw4906ko1dsd4knwqqfi",
      style: "mapbox://styles/barbotha/cjxyypdv80a9o1cl64y8kxdyg",
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        latitude: 53.3781,
        longitude: 5.036,
        zoom: 4.5
      }
    };

    //this.handleChange = this.handleChange.bind(this);
    //this.checkCityData = this.checkCityData.bind(this);
    //this.loadCityData = this.loadCityData.bind(this);
    //this.delete = this.delete.bind(this);
  }

  _renderCityMarker = (city, index) => {
    return (
      <Marker
        key={`marker-${index}`}
        longitude={city.longitude}
        latitude={city.latitude}
      >
        <CityPin
          size={20}
          fillColour={"#ffffff"}
          //onClick={() => this.setState({ popupInfo: city })}
        />
        <div className="city-Label">{city.name}</div>
        <div className="temp-Label">{Math.floor(city.temp)} °C</div>
      </Marker>
    );
  };

  render() {
    return (
      <div className="map">
        <div className="background">
          <ReactMapGL
            mapboxApiAccessToken={
              "pk.eyJ1IjoiYmFyYm90aGEiLCJhIjoiY2p2ZWJpdWs2MjBxazQzcDhvaWRsOTRkdyJ9.out4_DFcaIW-0jYn6yKlWg"
            }
            {...this.state.viewport}
            mapStyle={this.state.style}
            onViewportChange={viewport => this.setState({ viewport })}
          >
            {this.props.items.map(this._renderCityMarker)}
          </ReactMapGL>
        </div>
      </div>
    );
  }
}

export default Map;
